import createReducer from "./../createReducer";
import { CollaboratorsState } from "./types";
import { handlersCollaborators } from "./handlers";
import { CollaborationStatus, CollaboratorRole } from "./../collaborators/types";

export const CollaboratorsInitialState: CollaboratorsState = {
    owner: {
        id: "9999",
        email: "hracho@boomte.ch",
        role: CollaboratorRole.Owner,
        status: CollaborationStatus.Approved,
    },
    list: [],
};

export default createReducer(CollaboratorsInitialState, handlersCollaborators);
